import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    firearmData: [],
    metadataFirearms: {
        limit: 0,
        offset: 0,
        total: 0,
    },
    firearmDetail: {},
}

const FirearmReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_FIREARMS:
            return {
                ...state,
                firearmData: action.payload.data,
                metadataFirearms: { ...action.payload.metadata },
            }
        case ClientActionTypes.GET_FIREARM_DETAIL:
            return {
                ...state,
                firearmDetail: action.payload,
            }

        default:
            return { ...state }
    }
}

export default FirearmReducer
